import { render, staticRenderFns } from "./MyFeedback.vue?vue&type=template&id=16703682&scoped=true"
import script from "./MyFeedback.vue?vue&type=script&lang=js"
export * from "./MyFeedback.vue?vue&type=script&lang=js"
import style0 from "./MyFeedback.vue?vue&type=style&index=0&id=16703682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16703682",
  null
  
)

export default component.exports